import { render, staticRenderFns } from "./shuyoubi.vue?vue&type=template&id=112f5bed&scoped=true"
import script from "./shuyoubi.vue?vue&type=script&lang=js"
export * from "./shuyoubi.vue?vue&type=script&lang=js"
import style0 from "./shuyoubi.vue?vue&type=style&index=0&id=112f5bed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112f5bed",
  null
  
)

export default component.exports